import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {CUSTOM_DASHBOARD_ROUTES} from '@constants/routes'
import EmbargoDatePage from "./Embargo";
import AmazonReleaseDatePage from "./AmazonReleaseDate";
import DynamicAssortmentPage from "./DynamicAssortment";
import AmazonPPKpisPage from "./AmazonPPKpis";


export const CustomDashboardRoutes = {
	path: CUSTOM_DASHBOARD_ROUTES.PATH,
	title: CUSTOM_DASHBOARD_ROUTES.TITLE,
	accessKey: CUSTOM_DASHBOARD_ROUTES.ACCESS_KEY,
	icon: 'passport',
	description: "Ensure Optimal Exposure of Your Products or Brand on Key E-commerce Sites",
	element: <AppLayout />,
	children: [{
		element: <Navigate to={CUSTOM_DASHBOARD_ROUTES.EMBARGO_PATH} replace />,  index: true
	}, {
		title: 'Embargo Date Compliance',
		path: CUSTOM_DASHBOARD_ROUTES.EMBARGO_PATH,
		dashboardKey: CUSTOM_DASHBOARD_ROUTES.EMBARGO_ID,
		element: <EmbargoDatePage />,
	}, {
		title: 'Amazon Release Date',
		path: CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_PATH,
		dashboardKey: CUSTOM_DASHBOARD_ROUTES.AMAZON_RELEASE_DATE_ID,
		element: <AmazonReleaseDatePage />,
	}, {
		title: 'Dynamic Assortment',
		path: CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_PATH,
		dashboardKey: CUSTOM_DASHBOARD_ROUTES.DYNAMIC_ASSORTMENT_ID,
		element: <DynamicAssortmentPage />
	}, {
		title: 'Amazon Product Page Kpis',
		path: CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_PATH,
		dashboardKey: CUSTOM_DASHBOARD_ROUTES.AMAZON_PP_KPIS_ID,
		element: <AmazonPPKpisPage />
	}]
}